import { useMemo } from "react";
import type { PerkspotSessionInfo } from "@/components/AuthModule/api/auth";
import { useSessionContext } from "@/components/AuthModule/SessionContext";
import { carsSectionBanners, matchEligibility } from "@/utils/banners";
import { Logger } from "@/utils/logging";

export const useCarsSectionBanners = () => {
  const { sessionInfo } = useSessionContext();

  return useMemo(() => {
    const allSections = carsSectionBanners;

    return {
      mainSection: allSections.mainSection.filter((banner) => {
        return matchEligibility(
          sessionInfo?.userDetails,
          banner.eligibilityPayloadMapping
        );
      }),
      carouselSection: allSections.carouselSection.filter((banner) => {
        return matchEligibility(
          sessionInfo?.userDetails,
          banner.eligibilityPayloadMapping
        );
      }),
    };
  }, [sessionInfo?.userDetails]);
};
